import { render, staticRenderFns } from "./FormPrivacyCheck.vue?vue&type=template&id=d991c972&scoped=true&lang=pug"
import script from "./FormPrivacyCheck.vue?vue&type=script&lang=ts"
export * from "./FormPrivacyCheck.vue?vue&type=script&lang=ts"
import style0 from "./FormPrivacyCheck.vue?vue&type=style&index=0&id=d991c972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d991c972",
  null
  
)

export default component.exports